import MileageDownloadAllCSVRequest, {
  MileageDownloadAllCSVRequestQueryParams,
} from "./mileage-download-all-csv.request";

const createQueryParams = (
  request: MileageDownloadAllCSVRequest,
): MileageDownloadAllCSVRequestQueryParams => {
  return {
    address: request.address,
    card_number: request.card_number,
    company_id: request.company_id,
    date_since: request.date_since,
    date_to: request.date_to,
    cargo_company_name: request.cargo_company_name,
    distance_max: request.distance_max,
    distance_min: request.distance_min,
    end_address: request.end_address,
    human_id: request.human_id,
    mid_address: request.mid_address,
    mileage_number: request.mileage_number,
    start_address: request.start_address,
    worker_name: request.worker_name,
    order: request.order,
    vehicle_type: request.vehicle_type,
    state: request.state,
  };
};

const mileageDownloadAllCSVRequestFactory = {
  createQueryParams,
};

export default mileageDownloadAllCSVRequestFactory;
